<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      ბაქსვუდის სკოლა <br />
      Ad Vitam Paramus - ვამზადებთ ცხოვრებისთვის
    </h1>
    <h6>დეკემბერი 2023</h6>
    <br />

    <img src="../../../../assets/blog/buckswood-school/img1.jpg" alt="" />

    <p>
      ბაქსვუდის საერთაშორისო სკოლა „გაეროს ასოციაციის საერთაშორისო სკოლის“ სახელით თბილისში 2000 წელს დაარსდა. ეს არის
      საქართველოში პირველი ტრადიციულ ბრიტანულ საგანმანათლებლო მოდელზე აგებული სასწავლო სივრცე. განვითარების პერიოდში
      ბაქსვუდის ყოველი ახალი სასწავლო წელი ადასტურებს დამფუძნებლების პროფესიონალურ ხედვასა და სწორ ღირებულებებს.
    </p>

    <p>
      ეს ხედვა ემყარება უმაღლესი სტანდარტის ბრიტანულ და ქართულ სააღმზრდელო პრინციპებს. ყოველი აკადემიური,
      ინფრასტრუქტურული თუ შიდა კულტურული ინოვაცია ემსახურება მხოლოდ და მხოლოდ მომავალი თაობების აღზრდას საზოგადობის
      სრულფასოვან და ღირსეულ წევრებად, შრომისმოყვარე, მიზანდასახულ, პასუხისმგებლიან, სამართლიან და წარმატებულ
      მოქალაქეებად.
    </p>

    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ჩვენი წარმატების განმაპირობებელი, მეტწილად ის ხედვაა, რომელსაც ბაქსვუდის სკოლა დაარსების დღიდან ეფუძნება. სკოლის
        გუნდს მიაჩნია, რომ თითოეული თანამშრომელი ემსახურება მოსწავლის პიროვნულ და ფსიქოემოციურ განვითარებას შემდეგი
        პრიორიტეტებით: ბავშვი, როგორც პიროვნება - (ბედნიერი და რეალიზებული) ბავშვი, როგორც მოქალაქე - (ღირსეული და
        ერუდირებული) ბავშვი, როგორც პოტენციური ლიდერი - (მაძიებელი და შემქმნელი).
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/buckswood-school/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      მომავალი თაობისთვის სწორი ღირებულებების მისაცემად სკოლა ზრუნავს არა მხოლოდ უსაფრთხოებაზე, არამედ -
      ეკომეგობრულობაზეც, რასაც მისი გადაწყვეტილებები მოწმობს. წყნეთის კამპუსი ფაქტობრივად სრულად ენერგოეფექტურია. თიბისი
      ლიზინგის დაფინანსებით მზის ელექტროსადგური მოეწყო. ტერიტორიაზე განთავსებული მზის ფოტოელექტრონული მოდულების
      მომწოდებელი პარტნიორი - ენოვუსია.
    </p>

    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ის რასაც მოსწავლე ადგილზე ხედავს, ხდება მისი ღირებულებების განმსაზღვრელი. სწორედ ამიტომ, მნიშვნელოვანია ჩვენი
        სკოლის ეკომეგობრული პოლიტიკა, რომელიც სამაგალითოა მომავალი თაობისთვისაც.
      </b>
    </p>

    <p>
      ასევე, სკოლა წელს ახალ ლოკაციაზეც გაიხსნა. გელოვანზე არსებული კამპუსი საგანმანათლებლო, სპორტულ და გასართობ
      ინფრასტრუქტურას მოიცავს და დაპროექტებულია საერთაშორისო და ქართველ არქიტექტორთა პროფესიონალი გუნდის მიერ. შენობის
      ერთ-ერთი უპირატესობა ამ შემთხვევაშიც მისი ენერგოეფექტურობაა.
    </p>

    <p>
      ეს არ გახლავთ თიბისი ლიზინგის და ბაქსვუდის სკოლის თანამშრომლობის პირველი შემთხვევა, რამდენიმე წლის წინ, მოსწავლეთა
      უსაფრთხო და კომფორტული გადაადგილებისთვის საჭირო ავტობუსები დავაფინანსეთ.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/buckswood-school/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        თიბისი ლიზინგთან უკვე რამდენიმეწლიანი მეგობრობა გვაკავშირებს, რაც სხვადასხვა დროს, სხვადასხვა პროდუქტის
        ფარგლებში თანამშრომლობას მოიაზრებს. ამ ურთიერთობის კომფორტულობას კი მიმართვიდან რამდენიმე საათში დაკმაყოფილება
        და მოქნილი საოპერაციო ნაწილი განაპირობებს. და რადგან ბაქსვუდის საერთაშორისო სკოლა ინოვაციების გზაზე გაჩერებას არ
        აპირებს, იმედი გვაქვს კიდევ უფრო მეტ სიახლეს შევთავაზებთ ქართულ საზოგადოებას.
      </b>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      Backwoods School<br />
      Ad Vitam Paramus - We prepare for life
    </h1>
    <h6>December 2023</h6>
    <br />

    <img src="../../../../assets/blog/buckswood-school/img1.jpg" alt="" />

    <p>
      Backwoods International School, founded in 2000 in Tbilisi under the name of the "United Nations Association
      International School," is the first educational space in Georgia built on the traditional British educational
      model. Throughout its development, each new academic year at Backwoods confirms the professional vision and
      correct values of its founders.
    </p>

    <p>
      This vision is based on the highest standards of British and Georgian educational principles. Every academic,
      infrastructural, and internal cultural innovation serves only the upbringing of future generations as full and
      dignified members of society, hardworking, goal-oriented, responsible, fair, and successful citizens.
    </p>

    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Our success is largely determined by the vision that Backwoods School has followed since its founding. The
        school team believes that each staff member serves the personal and psycho-emotional development of the student
        with the following priorities: the child as an individual (happy and realized), the child as a citizen (worthy
        and educated), the child as a potential leader (a seeker and creator).
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/buckswood-school/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      To provide the correct values for future generations, the school cares not only about safety but also about
      eco-friendliness, as evidenced by its decisions. The Tskneti campus is practically fully energy-efficient. With
      funding from TBC Leasing, a solar power plant has been installed. The supplier partner of the solar photovoltaic
      modules located on the premises is Enovus.
    </p>

    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        What the student sees on-site becomes a determinant of their values. That is why our school's eco-friendly
        policy is so important, as it sets an example for future generations as well.
      </b>
    </p>

    <p>
      Additionally, the school has opened a new location this year. The campus in Gelovani includes educational, sports,
      and recreational infrastructure and has been designed by a professional team of international and Georgian
      architects. One of the building’s advantages is, once again, its energy efficiency.
    </p>

    <p>
      This is not the first collaboration between TBC Leasing and Backwoods School. A few years ago, we financed buses
      necessary for the safe and comfortable transportation of students.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/buckswood-school/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign green">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        We have had a several-year-long friendship with TBC Leasing, which has involved collaboration at different times
        and under various products. The comfort of this relationship is determined by the fulfillment of requests within
        a few hours and a flexible operational process. And since Backwoods International School has no intention of
        stopping on the path of innovation, we hope to offer even more new things to the Georgian society.
      </b>
    </p>
  </div>
</ng-container>
